'use client'
import { FC, ReactNode } from 'react'
import { DeliveryDTO, Option } from 'ecosystem'
import { NotificationsProvider } from 'storefront-modules/notifications'
import { AihubAnalyticsProvider } from 'storefront-modules/aihub'
import { CustomAiHub } from '#/src/custom/components/CustomAiHub'
import { useGTMPageViewTracker } from 'storefront-modules/data-collection'

interface AppComponentProps {
  children: ReactNode
  deliveries?: Option<DeliveryDTO[]>
}

const AppComponent: FC<AppComponentProps> = ({ children, deliveries }) => {
  useGTMPageViewTracker()

  return (
    <NotificationsProvider isDebug>
      <AihubAnalyticsProvider>
        {children}
        <CustomAiHub deliveries={deliveries} />
      </AihubAnalyticsProvider>
    </NotificationsProvider>
  )
}

export default AppComponent
